<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ newStep ? 'Add new step': step.title }}</p>
        <button class="delete"  @click="$emit('closeModal')"></button>
      </header>
      <section class="modal-card-body">
        <form>
          <div class="frow gutters mb-20">
            <div class="col-sm-1-2">
              <div>
                <label for="title">Title</label>
                <input
                    v-model="step.title"
                    class="input"
                    id="title"
                    name="title"
                    type="text"
                    value="Havens House - Step 1"
                />
              </div>
            </div>
            <div class="col-sm-1-2">
              <div>
              <label for="order">
                Order
              </label>
              <input
                v-model="step.order"
                class="input"
                id="order"
                name="order"
                type="number"
              >
            </div>
            </div>
          </div>

          <div class="frow gutters mb-20">
            <div class="col-sm-1-2">
              <!-- Hide image upload if video exists -->
              <div
                v-if="hasVideo"
                class="notification is-info is-light"
                style="padding: 15px; margin-bottom: 10px;"
              >
                <p style="font-size: 0.875rem; margin: 0;">
                  <i class="fas fa-info-circle"></i>
                  Image upload is only available when there is no video.
                  Remove the video below to enable image upload.
                </p>
              </div>
              <div v-if="!hasVideo" class="file has-name is-boxed">
                <label
                    class="file-label"
                    for="image"
                >
                  <input
                      id="image"
                      class="file-input"
                      type="file"
                      @change="uploadImage"
                  />
                  <span class="file-cta">
                    <br />
                    <span class="file-icon">
                      <i class="fas fa-file-image fa-3x"></i>
                    </span>
                    <br />
                     <span class="file-label">
                        Upload Image
                     </span>
                   </span>
                </label>
              </div>
              <div v-if="step.image || step.uploadedImageUrl">
                <img :src="imageURL" />
                <span
                  class="has-text-danger delete-image"
                  @click="deleteImage()"
                  style="display: block; margin-top: 10px; cursor: pointer;"
                >
                  Remove Image
                </span>
              </div>
              <br />
              <!-- Hide video upload if image or audio exists -->
              <div
                v-if="hasImageOrAudio"
                class="notification is-info is-light"
                style="padding: 15px; margin-top: 10px;"
              >
                <p style="font-size: 0.875rem; margin: 0;">
                  <i class="fas fa-info-circle"></i>
                  Video upload is only available when there is no image or audio.
                  Remove the image/audio above to enable video upload.
                </p>
              </div>
              <div v-if="!hasImageOrAudio" class="file has-name is-boxed">
                <label
                    class="file-label"
                    for="video"
                >
                  <input
                      id="video"
                      class="file-input"
                      type="file"
                      @change="uploadVideo"
                  />
                  <span class="file-cta">
                    <br />
                    <span class="file-icon">
                      <i class="fas fa-file-video fa-3x"></i>
                    </span>
                    <br />
                     <span class="file-label">
                        Upload Video
                     </span>
                   </span>
                </label>
              </div>
              <div
                v-if="(step.video && step.video.url) ||
                       step.uploadedVideoUrl ||
                       videoPreviewUrl"
              >
                <div v-if="videoUploading" class="has-text-info">
                  <i class="fas fa-spinner fa-spin"></i> Uploading video...
                </div>
                <div v-if="step.video && step.video.name">{{ step.video.name }}</div>
                <video
                  v-if="videoURL"
                  :src="videoURL"
                  controls
                  style="max-width: 100%; max-height: 200px;"
                  @error="handleVideoError"
                  @loadeddata="handleVideoLoaded"
                ></video>
                <div
                  v-if="videoPreviewUrl && !step.video"
                  class="has-text-warning"
                  style="font-size: 0.875rem; margin-top: 5px;"
                >
                  <small>Preview only - Click "Save changes" to upload</small>
                </div>
                <span
                  v-if="step.video || step.uploadedVideoUrl"
                  class="has-text-danger delete-video"
                  @click="deleteVideo()"
                  style="display: block; margin-top: 10px; cursor: pointer;"
                >
                  Remove Video
                </span>
                <span
                  v-if="videoPreviewUrl && !step.video"
                  class="has-text-danger delete-video"
                  @click="clearVideoPreview()"
                  style="display: block; margin-top: 10px; cursor: pointer;"
                >
                  Remove Video
                </span>
              </div>
            </div>
            <div class="col-sm-1-2">
              <!-- Hide audio upload if video exists -->
              <div
                v-if="hasVideo"
                class="notification is-info is-light"
                style="padding: 15px; margin-bottom: 10px;"
              >
                <p style="font-size: 0.875rem; margin: 0;">
                  <i class="fas fa-info-circle"></i>
                  Audio upload is only available when there is no video.
                  Remove the video below to enable audio upload.
                </p>
              </div>
              <div v-if="!hasVideo" class="file has-name is-boxed">
                <label
                    class="file-label"
                    for="audio"
                >
                  <input
                      id="audio"
                      class="file-input"
                      type="file"
                      @change="uploadAudio"
                  />
                  <span class="file-cta">
                    <br />
                    <span class="file-icon">
                      <i class="fas fa-file-audio fa-3x"></i>
                    </span>
                    <br />
                     <span class="file-label">
                        Upload Audio
                     </span>
                   </span>
                </label>
              </div>
              <div v-if="(step.audio && step.audio.url) || step.uploadedAudioUrl">
                <div v-if="step.audio && step.audio.name">{{ step.audio.name }}</div>
                <a
                  :href="audioURL"
                  target="_blank"
                >
                  Preview Audio
                </a>
                <span
                  class="has-text-danger delete-audio"
                  @click="deleteAudio()"
                  style="display: block; margin-top: 10px; cursor: pointer;"
                >
                  Remove Audio
                </span>
                <!-- <audio controls v-if="step.audio">
                  <source :src="audioURL" type="audio/mpeg">
                  Your browser does not support the audio element.
                </audio> -->
              </div>
              <br />
              <div>
                <label for="title">Img Alt Tag</label>
                  <input
                      v-model="step.altText"
                      class="input"
                      id="alt"
                      name="alt"
                      type="text"
                  />
              </div>
            </div>
          </div>

          <div>
            <label for="text">
              Text
            </label>
            <textarea
              v-model="step.text"
              class="textarea"
              id="text"
              name="text"
            ></textarea>
          </div>
        </form>
      </section>
      <footer class="modal-card-foot frow row-between">
        <div>
          <button
            class="button is-success"
            :disabled="saving"
            @click="saveStep"
          >
            {{ saving ? 'Saving...' : 'Save changes' }}
          </button>
          <button class="button" @click="$emit('closeModal')">Cancel</button>
        </div>
        <div>
          <button
            v-if="!newStep"
            class="button is-danger"
            @click="deleteStep"
          >
            Delete Step
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'step-modal',
  props: {
    step: {
      type: Object,
    },
    newStep: {
      type: Boolean,
      default: false,
    },
    project: {
      type: Object,
    },
  },

  data() {
    return {
      saveNewStep: false,
      newImage: null,
      newAudio: null,
      newVideo: null,
      videoPreviewUrl: null,
      videoUploading: false,
      saving: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.profile.user,
      jwt: state => state.profile.jwt,
    }),
    API() {
      return this.$API;
    },
    imageURL() {
      if (this.step.uploadedImageUrl) {
        return this.step.uploadedImageUrl;
      }
      if (this.step.image && this.step.image.url) {
        return `${this.API}${this.step.image.url}`;
      }
      return null;
    },
    audioURL() {
      if (this.step.uploadedAudioUrl) {
        return this.step.uploadedAudioUrl;
      }
      if (this.step.audio && this.step.audio.url) {
        return `${this.API}${this.step.audio.url}`;
      }
      return null;
    },
    videoURL() {
      // Always prefer preview URL if it exists (user just selected file)
      // This prevents flashing - we keep preview until step is saved
      if (this.videoPreviewUrl) {
        return this.videoPreviewUrl;
      }
      // Then uploaded URL (just uploaded but step not saved yet)
      if (this.step.uploadedVideoUrl) {
        // If it's already a full URL, use it; otherwise prepend API
        const url = this.step.uploadedVideoUrl;
        if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//')) {
          return url;
        }
        return `${this.API}${url}`;
      }
      // Finally, use saved video URL
      if (this.step.video && this.step.video.url) {
        return `${this.API}${this.step.video.url}`;
      }
      return null;
    },
    hasImageOrAudio() {
      return (this.step.image && this.step.image.url)
             || this.step.uploadedImageUrl
             || (this.step.audio && this.step.audio.url)
             || this.step.uploadedAudioUrl;
    },
    hasVideo() {
      return (this.step.video && this.step.video.url)
             || this.step.uploadedVideoUrl
             || this.videoPreviewUrl;
    },
  },
  methods: {
    deleteAudio() {
      if (confirm('Are you sure you want to delete this audio file?')) {
        // Delete from server if it exists
        if (this.step.audio && this.step.audio.id) {
          const url = `${this.$API}/upload/files/${this.step.audio.id}`;
          this.axios({
            method: 'DELETE',
            headers: {
              Authorization: `Bearer ${this.jwt}`,
            },
            url,
          }).then(() => {
            this.$set(this.step, 'audio', null);
            this.$set(this.step, 'uploadedAudioUrl', null);
            this.saveStepWithoutClose();
          });
        } else {
          // Just clear and save
          this.$set(this.step, 'audio', null);
          this.$set(this.step, 'uploadedAudioUrl', null);
          this.saveStepWithoutClose();
        }
      }
    },
    deleteImage() {
      if (confirm('Are you sure you want to delete this image file?')) {
        // Delete from server if it exists
        if (this.step.image && this.step.image.id) {
          const url = `${this.$API}/upload/files/${this.step.image.id}`;
          this.axios({
            method: 'DELETE',
            headers: {
              Authorization: `Bearer ${this.jwt}`,
            },
            url,
          }).then(() => {
            this.$set(this.step, 'image', null);
            this.$set(this.step, 'uploadedImageUrl', null);
            this.saveStepWithoutClose();
          });
        } else {
          // Just clear and save
          this.$set(this.step, 'image', null);
          this.$set(this.step, 'uploadedImageUrl', null);
          this.saveStepWithoutClose();
        }
      }
    },
    deleteVideo() {
      if (confirm('Are you sure you want to delete this video file?')) {
        // Clear preview if it exists
        this.clearVideoPreview();

        // Delete from server if it exists
        if (this.step.video && this.step.video.id) {
          const url = `${this.$API}/upload/files/${this.step.video.id}`;
          this.axios({
            method: 'DELETE',
            headers: {
              Authorization: `Bearer ${this.jwt}`,
            },
            url,
          }).then(() => {
            this.$set(this.step, 'video', null);
            this.$set(this.step, 'uploadedVideoUrl', null);
            this.saveStepWithoutClose();
          });
        } else {
          // Just clear the preview and save
          this.saveStepWithoutClose();
        }
      }
    },
    deleteStep() {
      const confirm = prompt(
        `Are you sure you want to DELETE this step? Type  "${this.step.title}" to delete.`,
        '',
      );
      if (confirm === this.step.title) {
        this.axios({
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${this.jwt}`,
          },
          url: `${this.$API}/steps/${this.step.id}`,
        }).then(() => {
          this.$emit('closeModal');
        });
      }
    },
    saveStep() {
      if (this.saving) {
        return;
      }
      this.saving = true;
      const method = this.newStep ? 'POST' : 'PUT';
      const url = this.newStep ? `${this.$API}/steps/` : `${this.$API}/steps/${this.step.id}`;

      if (this.newStep) {
        this.step.project = this.project.id;
      }

      const data = this.step;
      if (this.step.uploadedImageUrl) {
        delete data.image;
        delete data.uploadedImageUrl;
      }
      if (this.step.uploadedAudioUrl) {
        delete data.audio;
        delete data.uploadedAudioUrl;
      }
      if (this.step.uploadedVideoUrl) {
        delete data.video;
        delete data.uploadedVideoUrl;
      }

      this.axios({
        method,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        data,
        url,
      })
        .then((response) => {
          if (response.status === 200) {
            if (this.newStep) {
              this.step = response.data;
              this.saveNewStep = true;
              if (this.newImage) {
                this.uploadImage(this.newImage);
              }
              if (this.newAudio) {
                this.uploadAudio(this.newAudio);
              }
              if (this.newVideo
                  && this.newVideo.target
                  && this.newVideo.target.files
                  && this.newVideo.target.files[0]) {
                this.uploadVideoToServer(this.newVideo.target.files[0]);
              }
            }
            this.$emit('closeModal');
          }
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.saving = false;
        });
    },
    saveStepWithoutClose() {
      // Same logic as saveStep but without closing the modal
      if (!this.step.id && !this.newStep) {
        // Can't save if step doesn't exist and it's not a new step
        return;
      }

      const method = this.newStep ? 'POST' : 'PUT';
      const url = this.newStep ? `${this.$API}/steps/` : `${this.$API}/steps/${this.step.id}`;

      if (this.newStep) {
        this.step.project = this.project.id;
      }

      const data = this.step;
      if (this.step.uploadedImageUrl) {
        delete data.image;
        delete data.uploadedImageUrl;
      }
      if (this.step.uploadedAudioUrl) {
        delete data.audio;
        delete data.uploadedAudioUrl;
      }
      if (this.step.uploadedVideoUrl) {
        delete data.video;
        delete data.uploadedVideoUrl;
      }

      this.axios({
        method,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        data,
        url,
      })
        .then((response) => {
          if (response.status === 200) {
            if (this.newStep) {
              this.step = response.data;
              this.saveNewStep = true;
              if (this.newImage) {
                this.uploadImage(this.newImage);
              }
              if (this.newAudio) {
                this.uploadAudio(this.newAudio);
              }
              if (this.newVideo
                  && this.newVideo.target
                  && this.newVideo.target.files
                  && this.newVideo.target.files[0]) {
                this.uploadVideoToServer(this.newVideo.target.files[0]);
              }
            }
            // Don't emit closeModal - stay in the modal
          }
        })
        .catch(err => console.log(err));
    },
    uploadImage(e) {
      if ((!this.newStep || this.saveNewStep) && e !== null) {
        const body = new FormData();

        body.append('refId', this.step.id);
        body.append('ref', 'step');
        body.append('field', 'image');
        body.append('files', e.target.files[0]);

        const request = new XMLHttpRequest();

        request.onreadystatechange = () => {
          if (request.readyState === XMLHttpRequest.DONE) {
            this.$set(this.step, 'uploadedImageUrl', JSON.parse(request.response)[0].url);
          }
        };

        request.open('POST', `${this.$API}/upload`);
        request.setRequestHeader('Authorization', `Bearer ${this.jwt}`);
        request.send(body);
      } else {
        this.newImage = e;
      }
    },
    uploadAudio(e) {
      if ((!this.newStep || this.saveNewStep) && e !== null) {
        const body = new FormData();

        body.append('refId', this.step.id);
        body.append('ref', 'step');
        body.append('field', 'audio');
        body.append('files', e.target.files[0]);

        const request = new XMLHttpRequest();

        request.onreadystatechange = () => {
          if (request.readyState === XMLHttpRequest.DONE) {
            this.$set(this.step, 'uploadedAudioUrl', JSON.parse(request.response)[0].url);
          }
        };

        request.open('POST', `${this.$API}/upload`);
        request.setRequestHeader('Authorization', `Bearer ${this.jwt}`);
        request.send(body);
      } else {
        this.newAudio = e;
      }
    },
    uploadVideo(e) {
      if (!e || !e.target || !e.target.files || !e.target.files[0]) {
        return;
      }

      const file = e.target.files[0];

      // Create immediate preview using FileReader
      if (this.videoPreviewUrl) {
        URL.revokeObjectURL(this.videoPreviewUrl);
      }
      this.videoPreviewUrl = URL.createObjectURL(file);
      this.newVideo = e;

      // For existing steps, upload immediately
      if (!this.newStep && this.step.id) {
        this.uploadVideoToServer(file);
      }
      // For new steps, upload happens after save (handled in saveStep)
    },
    uploadVideoToServer(file) {
      if (!this.step.id) {
        return;
      }

      this.videoUploading = true;
      const body = new FormData();

      body.append('refId', this.step.id);
      body.append('ref', 'step');
      body.append('field', 'video');
      body.append('files', file);

      const request = new XMLHttpRequest();

      request.onreadystatechange = () => {
        if (request.readyState === XMLHttpRequest.DONE) {
          this.videoUploading = false;
          if (request.status === 200) {
            const response = JSON.parse(request.response);
            if (response && response[0] && response[0].url) {
              const uploadedUrl = response[0].url;
              // Ensure we have a full URL
              let fullUrl = uploadedUrl;
              if (!uploadedUrl.startsWith('http://') && !uploadedUrl.startsWith('https://') && !uploadedUrl.startsWith('//')) {
                fullUrl = `${this.API}${uploadedUrl}`;
              }

              this.$set(this.step, 'uploadedVideoUrl', fullUrl);

              // Keep preview URL active - we'll only switch to server URL after it loads
              // Don't clear preview immediately to avoid flashing
              // Preview will be cleared when step is saved or if user removes video
            }
          } else {
            console.error('Video upload failed:', request.status, request.responseText);
            // Keep preview URL on error so user can still see their selection
          }
        }
      };

      request.onerror = () => {
        this.videoUploading = false;
        console.error('Video upload error');
      };

      request.open('POST', `${this.$API}/upload`);
      request.setRequestHeader('Authorization', `Bearer ${this.jwt}`);
      request.send(body);
    },
    clearVideoPreview() {
      if (this.videoPreviewUrl) {
        URL.revokeObjectURL(this.videoPreviewUrl);
        this.videoPreviewUrl = null;
      }
      this.newVideo = null;
      // Reset file input
      const videoInput = document.getElementById('video');
      if (videoInput) {
        videoInput.value = '';
      }
    },
    handleVideoError(e) {
      console.error('Video loading error:', e);
      // If server URL fails to load, keep using preview URL
      if (this.step.uploadedVideoUrl && this.videoPreviewUrl) {
        console.warn('Server video URL failed, keeping preview URL active');
        // Don't clear preview - let user see their video
      }
    },
    handleVideoLoaded() {
      // Video loaded successfully - this can be from preview or server URL
      // We don't need to do anything special here since preview URL
      // will be cleared when step is saved
    },
  },
  beforeDestroy() {
    // Clean up object URL to prevent memory leaks
    if (this.videoPreviewUrl) {
      URL.revokeObjectURL(this.videoPreviewUrl);
    }
  },
};
</script>
<style lang="scss" scoped>
.delete-audio,
.delete-video,
.delete-image {
  cursor: pointer;
}

.video-upload-status {
  margin-top: 10px;
  font-size: 0.875rem;
}
</style>
